var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(_vm.appStyle),attrs:{"id":"app"}},[_c('emp-base-layout',{scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('emp-nav-header')]},proxy:true}])},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }